import type { NodeUser } from 'models';
import { useEffect } from 'react';
import { Loading } from 'ui';
import { useUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useNodeUserQuery } from 'features/chat/queries';

type P = {
  memberId: string;
  navigateToChat: (user: NodeUser) => void;
  navigateToProfile: (userId: string) => void;
};

const MemberMessage = ({ memberId, navigateToChat, navigateToProfile }: P) => {
  const {
    data: member,
    error: memberFetchError,
    isFetching: isFetchingMember,
  } = useNodeUserQuery({ railsId: memberId }, { throwOnError: false });

  const { railsUserData: viewer } = useUser();

  useEffect(() => {
    if (member && !isFetchingMember) {
      if (viewer.id === memberId) {
        navigateToProfile(memberId);
      } else {
        navigateToChat(member);
      }
    }
  }, [member, isFetchingMember, navigateToChat, viewer.id, memberId, navigateToProfile]);

  useEffect(() => {
    if (memberFetchError) {
      navigateToProfile(memberId);
    }
  }, [memberFetchError, memberId, navigateToProfile]);

  return <Loading />;
};

export default MemberMessage;
